export const SupportedVendors = ['Amazon', 'External', 'Squirrel', 'Trackonomics'];
//# sourceMappingURL=vendors.js.map